import { stripTags } from './text';
import type { JsonLdDocument, JsonLdNode } from './types';
import { SCHEMA_CONTEXT } from './types';

export interface FaqJsonLdItem {
  title?: string | null;
  answer?: string | null;
}

export const buildFaqPage = (
  items: ReadonlyArray<FaqJsonLdItem | null | undefined> | null | undefined,
  url: string
): JsonLdDocument | null => {
  const mainEntity: JsonLdNode[] = [];
  (items ?? []).forEach(item => {
    const name = stripTags(item?.title);
    const text = stripTags(item?.answer);
    if (name && text) {
      mainEntity.push({
        '@type': 'Question',
        name,
        acceptedAnswer: { '@type': 'Answer', text }
      });
    }
  });
  if (mainEntity.length === 0) {
    return null;
  }
  return {
    '@context': SCHEMA_CONTEXT,
    '@type': 'FAQPage',
    '@id': `${url}#faq`,
    url,
    mainEntity
  };
};
